import { isString } from "angular-ui-router";

class Controller {
  constructor(
    $timeout,
    $injector,
    $state,
    $stateParams,
    $rootScope,
    Logout,
    localStorageService,
    Lists,
    Authentication,
    GoogleAuth
  ) {
    "ngInject";
    this.Lists = Lists;
    this.Events = $injector.get("Events");
    this.City = $injector.get("City");
    this.$timeout = $timeout;
    this.$state = $state;
    this.$rootScope = $rootScope;
    this.CityHandler = $injector.get("CityHandler");
    this.$stateParams = $stateParams;
    this.errorEvent = this.Events.eventsType.onShowErrorNotification;
    this.Logout = Logout;
    this.Authentication = Authentication;
    this.localStorageService = localStorageService;
    this.showRamadan = false;
    this.GoogleAuth = GoogleAuth;

    this.onSelectCity = this.Events.getUpdateEvent("selectCity");
  }

  $onInit() {
    const onOpenSidenavEvent = this.Events.eventsType.onOpenSidenav;
    const reload = () => {
      this.$state.transitionTo(this.$state.current, this.$stateParams, {
        reload: true,
        inherit: false,
        notify: true,
      });
    };

    const formatCity = (city) => {
      return {
        _id: city._id,
        name: isString(city.name_i18n.en)
          ? city.name_i18n.en.toLowerCase()
          : city.name.toLowerCase(),
        title: isString(city.name_i18n.en) ? city.name_i18n.en : city.name,
        languages: city.languages,
        timezone: city.timezone,
        active: city.active,
        currency: city.currency,
        pricing_parameters: city.pricing_parameters,
      };
    };
    this.city = this.CityHandler.get();
    this.openSidenav = () => this.Events.emit(onOpenSidenavEvent, {});
    this.switchCity = (city) => {
      const cityDetails = city.name;
      if (cityDetails && cityDetails._id) {
        this.City.get(cityDetails._id).$promise.then((res) => {
          const selectedCity = formatCity(res);
          this.CityHandler.set(selectedCity);
          this.city = selectedCity;
          reload();
        });
      } else {
        this.CityHandler.remove();
        reload();
      }
    };
    this.ramadanStuff = (event) => {
      const { target } = event;
      this.ramadan = !this.ramadan;
      this.addRamadanDecoration = true;
      if (!this.ramadan) this.fanoosAnimationIteration(target);
    };
    this.isLoggedin = () => this.localStorageService.get("authdata") !== null;
    this.logout = () => {
      const refreshToken = this.Authentication.getRefreshToken();
      this.Logout.post({ refresh_token: refreshToken }).$promise.then(() => {
        if (this.GoogleAuth.isSignedInWithGoogle()) {
          this.GoogleAuth.signOut().then(() => {
            this.localStorageService.remove("authdata");
            this.$rootScope.isLoggedin = false;
            reload();
          });
        } else {
          this.localStorageService.remove("authdata");
          this.$rootScope.isLoggedin = false;
          reload();
        }
      });
    };
    this.Events.on(this.onSelectCity, this.switchCity);
  }
  fanoosAnimationIteration(target) {
    const fanoos = angular.element(target);
    const fanoosComputedStyle = window.getComputedStyle(target, null);
    const transform = fanoosComputedStyle.getPropertyValue("transform");
    fanoos.css({ transform });
    this.addRamadanDecoration = false;
    this.$timeout(() => {
      fanoos.css("transform", "");
    }, 50);
  }
}
export default Controller;



// WEBPACK FOOTER //
// ./src/components/mainHeader/mainHeader.controller.js